import type { RouteRecordMainRaw } from '@fantastic-admin/types'
import type { RouteRecordRaw } from 'vue-router'
import { $t } from '@/locales'
import pinia from '@/store'
import SchemaFormExample from './modules/schema.form.example'
import SchemaProTableExample from './modules/schema.pro.table.example'

// 固定路由（默认路由）
const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
    meta: {
      whiteList: true,
      title: $t('app.route.login'),
    },
  },
  {
    path: '/:all(.*)*',
    name: 'notFound',
    component: () => import('@/views/[...all].vue'),
    meta: {
      title: '找不到页面',
    },
  },
]

// 系统路由
const systemRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/index.vue'),
    meta: {
      breadcrumb: false,
    },
    children: [
      {
        path: '',
        component: () => import('@/views/index.vue'),
        meta: {
          title: $t(useAppSettingsStore(pinia).settings.app.home.title),
          icon: 'i-ant-design:home-twotone',
          breadcrumb: false,
        },
      },
      {
        path: 'dashboard/analysis',
        name: 'dashboardAnalysis',
        component: () => import('@/views/dashboard/analysis.vue'),
        meta: {
          title: '经营分析',
          activeMenu: '/',
          tabMerge: 'activeMenu',
        },
      },
      {
        path: 'reload',
        name: 'reload',
        component: () => import('@/views/reload.vue'),
        meta: {
          title: $t('app.route.reload'),
          breadcrumb: false,
        },
      },
    ],
  },
]

// 动态路由（保留前端模式示例，当前项目默认走后台动态路由）
const demoRoutes: RouteRecordMainRaw[] = true
  ? []
  : [
      {
        meta: {
          title: $t('route.demo'),
          icon: 'i-ri:function-ai-line',
        },
        children: [
          SchemaFormExample,
          SchemaProTableExample,
        ],
      },
    ]

const asyncRoutes: RouteRecordMainRaw[] = [
  ...demoRoutes,
]

export {
  asyncRoutes,
  constantRoutes,
  systemRoutes,
}
